import { render, staticRenderFns } from "./SpotTheNot.vue?vue&type=template&id=63b7035a&"
import script from "./SpotTheNot.vue?vue&type=script&lang=js&"
export * from "./SpotTheNot.vue?vue&type=script&lang=js&"
import style0 from "./SpotTheNot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports